import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Cta2 = ({ bgImage }) => {
  return (
    <section className="cta-2"
      style={{ "--cta2-bg": `url(${bgImage})` }}>
      <div className="cta-2-overlay">

        {/* HEADING */}
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          Looking for a Reliable Transportation Partner?
        </motion.h2>

        {/* TEXT */}
        <motion.p
          className="section-text"
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          viewport={{ once: true }}
        >
          Share your requirement and our team will help you plan the right logistics solution.
        </motion.p>

        {/* BUTTONS */}
        <motion.div
          className="cta-2-btns"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          viewport={{ once: true }}
        >
         {/* <Link to='/enquiry'>
          <motion.button
            className="primary-btn"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            Get a Quote
          </motion.button>
          </Link>*/}

          <Link to='contact-us'>
          <motion.button
            className="secondary-btn"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            Contact Us
          </motion.button>
          </Link>
        </motion.div>

      </div>
    </section>
  );
};

export default Cta2;
